<template>
  <div class="us_app">
    <section class="user_section">
      <div class="title jc">
        <h2>적립금 내역</h2>
      </div>

      <article class="view cmnity">
        <!-- 검색 영역 -->
        <div class="search_box" style="flex-wrap: wrap">
          <div class="flex items-center w100 mb10">
            <span class="mw80 fwb">조회기간</span>
            <Datepicker
              class="dp-wide"
              v-model="searchInfo.startDate"
              :defaultDate="searchInfo.startDate"
              :format="'YYYY-MM-DD'"
            />
            <span class="ml10 mr10">~</span>
            <Datepicker
              class="dp-wide"
              v-model="searchInfo.endDate"
              :defaultDate="searchInfo.endDate"
              :format="'YYYY-MM-DD'"
            />
            <button class="btn btn_md btn_darkbrown" style="margin-left: auto" @click="fn_search">검색</button>
            <button class="btn btn_md btn_brown" style="margin-left: 8px" @click="fn_openRequestHistory">요청내역</button>
            <button class="btn btn_md btn_brown" style="margin-left: 8px" @click="fn_openChargeModal">적립금 충전</button>
            <button class="guide_icon_btn" title="적립금 안내" @click="showPointGuide = true">?</button>
          </div>
        </div>

        <!-- 요약 카드 -->
        <div class="flex mb20">
          <div class="summary_card_main">
            <p class="summary_label_main">현재 잔여 적립금</p>
            <p class="summary_value_main">{{ fn_comma_won(currentDeposit) }} 원</p>
          </div>
        </div>

        <p class="w100 mb10">
          총 <strong> {{ searchInfo.pageInfo.totPage }} </strong>건
        </p>

        <!-- 목록 -->
        <div class="tab_contents">
          <div class="lay_left">
            <div class="table_list">
              <table class="list">
                <thead>
                  <tr>
                    <th>No</th>
                    <th>구분</th>
                    <th>금액</th>
                    <th>잔액</th>
                    <th>사유</th>
                    <th>일시</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="depositList.length === 0">
                    <td colspan="6"><span>데이터가 없습니다.</span></td>
                  </tr>
                  <tr v-for="(item, index) in depositList" :key="index">
                    <td>
                      <span>{{
                        searchInfo.pageInfo.totPage -
                        (searchInfo.pageInfo.page - 1) * searchInfo.pageInfo.pageSize -
                        index
                      }}</span>
                    </td>
                    <td>
                      <span >{{ item.tx_type_nm }}</span>
                    </td>
                    <td>
                      <span :class="item.tx_type === 'U' || item.tx_type === 'M' || item.tx_type === 'E'? 'font_red' : 'font_green'">
                        {{ item.tx_type === 'U' || item.tx_type === 'M' || item.tx_type === 'E' ? '-' : '+' }}{{ fn_comma_won(item.deposit) }} 원
                      </span>
                    </td>
                    <td>
                      <span :class="item.tx_type === 'U' || item.tx_type === 'M' || item.tx_type === 'E'? 'font_red' : 'font_green'">
                        {{ fn_comma_won(item.after_deposit) }} 원
                      </span>
                    </td>
                    <td>
                      <span >{{ item.reason }}</span>
                    </td>
                    <td>
                      <span>{{ item.reg_dt }}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <Pagination
              :pageInfo="searchInfo.pageInfo"
              @clickPage="fn_movePage"
              v-show="pagingShow"
            />
          </div>
        </div>
      </article>
    </section>

    <deposit-request-modal
      :isShow="showChargeModal"
      :clinicDoctorId="searchInfo.clinic_doctor_id"
      @close="showChargeModal = false"
      @showAlert="fn_open_alert"
      @reload="fn_search"
    />

    <div v-if="showPointGuide" class="guide_overlay" @click.self="showPointGuide = false">
      <div class="guide_modal">
        <button class="guide_close_btn" @click="showPointGuide = false">✕</button>
        <img src="@/assets/img/layout/point_guide.jpg" alt="적립금 안내" />
      </div>
    </div>

    <deposit-request-history-modal
      :clinicDoctorId="searchInfo.clinic_doctor_id"
    />

    <alert-modal
      :id="'alert'"
      :text="showAlertMsg"
      :btnRight="'확인'"
      :oneBtn="false"
      :isShow="showAlert"
      :className="'btn_brown'"
      :closeEventValue="closeEventValue"
      @closeEvent="oncCloseEvent"
      v-on:update:showSetting="fn_showSet"
    />
  </div>
</template>

<script>
import axios from 'axios'
import commonUtil from '@/mixin/commonUtil'
import alertutill from '@/mixin/alertModalUtill'
import Pagination from '@/components/AdminPagination.vue'
import Datepicker from '@/components/Datepicker.vue'
import AlertModal from '@/modal/common/alertModal.vue'
import DepositRequestModal from '@/modal/user/depositRequestModal.vue'
import DepositRequestHistoryModal from '@/modal/user/depositRequestHistoryModal.vue'

export default {
  components: {
    Pagination,
    Datepicker,
    AlertModal,
    DepositRequestModal,
    DepositRequestHistoryModal,
  },
  mixins: [commonUtil, alertutill],
  data() {
    return {
      searchInfo: {
        clinic_doctor_id: '',
        startDate: '',
        endDate: '',
        pageInfo: {
          page: 1,
          pageSize: 10,
          totPage: 0,
        },
      },
      pagingShow: false,
      depositList: [],
      currentDeposit: 0,
      showChargeModal: false,
      showPointGuide: false,
    }
  },
  created() {
    this.searchInfo.clinic_doctor_id =
      this.$store.getters['clinicDoctorInfo/getClinicDoctorId']
  },
  mounted() {
    this.searchInfo.startDate = this.getAddMonthDate(-3)
    this.searchInfo.endDate = this.getCurrentDate()
    this.fn_search();
  },
  methods: {
    fn_search() {
      this.searchInfo.pageInfo.page = 1
      this.fn_load()
    },
    fn_load() {
      axios
        .post('/api/user/mypage/getDepositList', this.searchInfo)
        .then((res) => {
          this.depositList = res.data.depositList
          this.currentDeposit = res.data.currentDepositInfo.deposit_balance;

          this.searchInfo.pageInfo.totPage = res.data.totCnt;
          this.pagingShow = this.searchInfo.pageInfo.totPage > 0
        })
        .catch((err) => console.log(err))
    },
    fn_movePage(page) {
      this.searchInfo.pageInfo.page = page
      this.fn_load()
    },
    oncCloseEvent() {
      this.fn_search()
    },
    fn_openChargeModal() {
      this.showChargeModal = true
    },
    fn_openRequestHistory() {
      this.$bvModal.show('depositRequestHistoryModal')
    },
  },
}
</script>

<style scoped>
.summary_card_main {
  width: 100%;
  border: 2px solid #8b6b3d;
  border-radius: 10px;
  padding: 20px 32px;
  background: #fdf3e3;
  text-align: center;
}
.summary_label_main {
  font-size: 14px;
  color: #7a5c2e;
  font-weight: 600;
  margin-bottom: 10px;
}
.summary_value_main {
  font-size: 28px;
  font-weight: bold;
  color: #1a5fa8;
}
.guide_icon_btn {
  width: 26px;
  height: 26px;
  margin-left: 6px;
  border: none;
  border-radius: 50%;
  background: #8b6b3d;
  color: #fff;
  font-size: 15px;
  font-weight: bold;
  line-height: 26px;
  padding: 0;
  cursor: pointer;
  flex-shrink: 0;
}
.guide_icon_btn:hover {
  background: #5a3e28;
}
.guide_overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}
.guide_modal {
  position: relative;
  max-width: 95vw;
  max-height: 90vh;
  overflow: auto;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.18);
}
.guide_modal img {
  display: block;
  width: 724px; /* 원본(1448px)의 50% */
  max-width: 100%;
}
.guide_close_btn {
  position: absolute;
  top: 10px;
  right: 12px;
  width: 30px;
  height: 30px;
  border: none;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.5);
  color: #fff;
  font-size: 15px;
  line-height: 30px;
  padding: 0;
  cursor: pointer;
}
</style>